import { useQuery } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import { IEmailSettings } from "./../../models/emailSettings/EmailSettings";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { emailSettingsQueryKeys } from "./queryKeys";

export function useEmailSettings(agencyId: string) {
  const { get } = useApiHelper();

  const emailSettings = useQuery({
    queryKey: emailSettingsQueryKeys.all(agencyId),
    queryFn: () =>
      get(
        `/marketing/${agencyId}/settings`
      ) as unknown as IDefaultResponseWithData<IEmailSettings>,
    refetchOnWindowFocus: false,
  });

  return {
    emailSettings,
  };
}
